import { Card, Flex } from "antd";

import { AuditAppointments } from "audit/components";
import variables from "../../../../../_variables.scss";
import { IAuditAppointment } from "audit/models";

type Props = {
  loading?: boolean;
  auditAppointments?: IAuditAppointment[];
};

export const FieldAuditorDashboardAuditAppointmentsCard = ({
  loading,
  auditAppointments,
}: Props) => {
  return (
    <Card
      loading={loading}
      bordered={false}
      data-testid='fieldAuditorDashboardAuditAppointmentsCard'
    >
      <Flex vertical gap={variables.gap}>
        <h1>Audit Appointments</h1>
        <AuditAppointments auditAppointments={auditAppointments ?? []} />
      </Flex>
    </Card>
  );
};
